export default "__VITE_ASSET__EYhxm6Gq__"